import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductEditorComponent } from './product-editor/product-editor.component';
import { UIModule } from '@common/UI/UI.module';
import { FormsModule } from '@angular/forms';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { PartnerEditorComponent } from './partner-editor/partner-editor.component';
import { ServiceEditorComponent } from './service-editor/service-editor.component';
import { GroupEditorComponent } from './group-editor/group-editor.component';
import { ProviderPaymentEditorComponent } from './provider-payment-editor/provider-payment-editor.component';
import { CoreModule } from '@core/core.module';
import { NgxLoadingModule } from 'ngx-loading';
import { GoodEditorComponent } from './good-editor/good-editor.component';
import { PartnerSelectorComponent } from './partner-selector/partner-selector.component';
import { CustomerPaymentEditorComponent } from './customer-payment-editor/customer-payment-editor.component';
import { CustomerDebtEditorComponent } from './customer-debt-editor/customer-debt-editor.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { TagEditorComponent } from './tag-editor/tag-editor.component';
import { ServicePaymentEditorComponent } from './service-payment-editor/service-payment-editor.component';



@NgModule({
  declarations: [
    ProductEditorComponent,
    UserEditorComponent,
    PartnerEditorComponent,
    ServiceEditorComponent,
    GroupEditorComponent,
    ProviderPaymentEditorComponent,
    GoodEditorComponent,
    PartnerSelectorComponent,
    CustomerPaymentEditorComponent,
    CustomerDebtEditorComponent,
    TextEditorComponent,
    TagEditorComponent,
    ServicePaymentEditorComponent
  ],
  imports: [
    CoreModule,
    UIModule,
    CommonModule,
    FormsModule,
    NgxLoadingModule
  ]
})
export class EditorsModule { }
